module.exports = __webpack_public_path__ + "media/images/official/removeanxieties_graph5-7ebdc517d6f91d9e07f276f5d8584334.png";